// Color maps for the original 6 people / 13 vendors that lived in code.
// Now used as fallbacks: API returns chip_color/avatar_color/tile_color from DB,
// but old chips fall back to these maps if a row lacks an explicit color.

export const PERSON_CHIP_COLORS: Record<string, string> = {
  Sruli: "bg-violet-50 text-violet-700",
  Isaac: "bg-blue-50 text-blue-700",
  Sam: "bg-emerald-50 text-emerald-700",
  Rivky: "bg-pink-50 text-pink-700",
  Annie: "bg-amber-50 text-amber-700",
  Steffi: "bg-cyan-50 text-cyan-700",
  default: "bg-slate-100 text-slate-600",
};

export const VENDOR_CHIP_COLORS: Record<string, string> = {
  SMPC: "bg-orange-50 text-orange-700 border-orange-200",
  TPA: "bg-sky-50 text-sky-700 border-sky-200",
  SCG: "bg-purple-50 text-purple-700 border-purple-200",
  Wode: "bg-teal-50 text-teal-700 border-teal-200",
  "Firm Tools": "bg-rose-50 text-rose-700 border-rose-200",
  "Metal Mate": "bg-zinc-100 text-zinc-700 border-zinc-200",
  "Grand Gas": "bg-lime-50 text-lime-700 border-lime-200",
  Namilux: "bg-indigo-50 text-indigo-700 border-indigo-200",
  Bobson: "bg-amber-50 text-amber-700 border-amber-200",
  Cavagna: "bg-pink-50 text-pink-700 border-pink-200",
  Junsky: "bg-cyan-50 text-cyan-700 border-cyan-200",
  Kingjoy: "bg-fuchsia-50 text-fuchsia-700 border-fuchsia-200",
  default: "bg-slate-50 text-slate-700 border-slate-200",
};

export const PERSON_AVATAR_COLORS: Record<string, string> = {
  Sruli: "bg-violet-500",
  Isaac: "bg-blue-500",
  Sam: "bg-emerald-500",
  Rivky: "bg-pink-500",
  Annie: "bg-amber-500",
  Steffi: "bg-cyan-500",
  default: "bg-slate-500",
};

export const VENDOR_TILE_COLORS: Record<string, string> = {
  SMPC: "bg-orange-100 text-orange-800 border-orange-300",
  TPA: "bg-sky-100 text-sky-800 border-sky-300",
  SCG: "bg-purple-100 text-purple-800 border-purple-300",
  Wode: "bg-teal-100 text-teal-800 border-teal-300",
  "Firm Tools": "bg-rose-100 text-rose-800 border-rose-300",
  "Metal Mate": "bg-zinc-200 text-zinc-800 border-zinc-300",
  "Grand Gas": "bg-lime-100 text-lime-800 border-lime-300",
  Namilux: "bg-indigo-100 text-indigo-800 border-indigo-300",
  Bobson: "bg-amber-100 text-amber-800 border-amber-300",
  Cavagna: "bg-pink-100 text-pink-800 border-pink-300",
  Junsky: "bg-cyan-100 text-cyan-800 border-cyan-300",
  Kingjoy: "bg-fuchsia-100 text-fuchsia-800 border-fuchsia-300",
  "Seven Universe": "bg-slate-100 text-slate-800 border-slate-300",
  default: "bg-slate-100 text-slate-800 border-slate-300",
};

export type Status = "todo" | "in_progress" | "waiting" | "done";

export type Priority = "high" | "medium" | "low";

export const TASK_CATEGORIES = [
  "Supplier",
  "Operations",
  "Product",
  "Compliance",
  "Finance",
];

export const STATUS_COLUMNS: { id: Status; label: string; color: string; dot: string }[] = [
  { id: "todo", label: "Todo", color: "bg-slate-100 text-slate-700", dot: "bg-slate-400" },
  { id: "in_progress", label: "In Progress", color: "bg-blue-50 text-blue-700", dot: "bg-blue-500" },
  { id: "waiting", label: "Waiting", color: "bg-amber-50 text-amber-700", dot: "bg-amber-500" },
  { id: "done", label: "Done", color: "bg-emerald-50 text-emerald-700", dot: "bg-emerald-500" },
];

export const PRIORITY_COLORS: Record<string, string> = {
  high: "bg-red-500",
  medium: "bg-amber-400",
  low: "bg-emerald-400",
};

export function normalizeStatus(s: string | null | undefined): Status {
  if (s === "review") return "in_progress";
  if (s === "todo" || s === "in_progress" || s === "waiting" || s === "done") return s;
  return "todo";
}

export function personChipClass(
  name: string,
  dbColor: string | null | undefined,
): string {
  return dbColor || PERSON_CHIP_COLORS[name] || PERSON_CHIP_COLORS.default;
}

export function vendorChipClass(
  name: string,
  dbColor: string | null | undefined,
): string {
  return dbColor || VENDOR_CHIP_COLORS[name] || VENDOR_CHIP_COLORS.default;
}

export function personAvatarClass(
  name: string,
  dbColor: string | null | undefined,
): string {
  return dbColor || PERSON_AVATAR_COLORS[name] || PERSON_AVATAR_COLORS.default;
}

export function vendorTileClass(
  name: string,
  dbColor: string | null | undefined,
): string {
  return dbColor || VENDOR_TILE_COLORS[name] || VENDOR_TILE_COLORS.default;
}
